import * as React from 'react';
import cx from 'clsx';

import { BottomNavigationProps, BottomNavigationItem } from './types';
import BottomNavigationSlot from './BottomNavigationSlot/BottomNavigationSlot';
import styles from './BottomNavigation.module.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
import { mapNavItems } from '../Navigation/utils';

import { mapUrl } from '../../logic/main/utils';
import { MEDIUM_BREAKPOINT } from '../modular-grid/constants';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  items,
  onBottomNavigationItemClick,
  onBottomNavigationGameClick,
  onBottomNavigationCommandClick,
  callbackMode,
  activeCommandItem,
  currentPagePath,
}) => {
  const { width, height } = useWindowSize();
  const { deviceType, deviceOs } = React.useContext(DeviceContext);

  const handleBottomNavigationClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    item: BottomNavigationItem
  ) => {
    const { route_link } = item;
    event.preventDefault();

    onBottomNavigationItemClick &&
      onBottomNavigationItemClick({
        itemTitle: item.tracking_metadata?.title || item.title,
        path: route_link,
      });
  };

  const [activeCommandTitle, setActiveCommandTitle] = React.useState<string>(
    ''
  );
  const activeCommand = activeCommandItem ? activeCommandTitle : '';
  const navItems = mapNavItems(items, [currentPagePath], {
    activeCommand,
    deviceOs,
  });
  const isBottomNavHidden =
    height < 225 || width > MEDIUM_BREAKPOINT.max ? true : false;

  return !isBottomNavHidden ? (
    <div className={styles.wrapper}>
      <div
        className={styles.slotWrapper}
        data-testid="bottom-navigation-slot-wrapper"
      >
        {navItems.map((item: any, index: number) => {
          const notIndexed = item.notIndexed ? 'nofollow' : '';

          if (item.url) {
            return (
              <div className={styles.slot} key={index} data-testid="slot">
                <a
                  className={styles.link}
                  href={item.url || ''}
                  target={item.target || ''}
                  rel="noopener noreferrer"
                >
                  <BottomNavigationSlot item={item} />
                </a>
              </div>
            );
          } else if (item.game) {
            return (
              <div className={styles.slot} key={index} data-testid="slot">
                <a
                  className={styles.link}
                  target="_blank"
                  rel={`noopener noreferrer ${notIndexed}`}
                  href={mapUrl(item.game!.launchUrl, deviceType, deviceOs)}
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    if (callbackMode === 'event') e.preventDefault();
                    onBottomNavigationGameClick &&
                      onBottomNavigationGameClick({
                        game: {
                          ...item.game,
                          trackingTitle:
                            item.game.tracking_metadata?.title ||
                            item.game.title,
                        },
                        itemTitle: item.title,
                        sectionTitle: 'Bottom Nav',
                        gamePosition: index + 1,
                      });
                  }}
                >
                  <BottomNavigationSlot item={item} />
                </a>
              </div>
            );
          } else if (item.command) {
            return (
              <div className={styles.slot} key={index} data-testid="slot">
                <a
                  className={styles.link}
                  rel={`noopener noreferrer ${notIndexed}`}
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    if (callbackMode === 'event') e.preventDefault();
                    onBottomNavigationCommandClick &&
                      onBottomNavigationCommandClick({
                        itemTitle: item.title,
                        command: item.command,
                      });
                    setActiveCommandTitle(item.title);
                  }}
                >
                  <BottomNavigationSlot item={item} />
                </a>
              </div>
            );
          }

          return (
            <div className={cx(styles.slot)} key={index} data-testid="slot">
              <a
                className={styles.link}
                onClick={e => handleBottomNavigationClick(e, item)}
                target="_self"
                href={item.route_link}
                rel={`noopener noreferrer ${notIndexed}`}
              >
                <BottomNavigationSlot item={item} />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default BottomNavigation;
